import { render, staticRenderFns } from "./comments-event-tab.vue?vue&type=template&id=c6869bca"
import script from "./comments-event-tab.vue?vue&type=script&lang=js"
export * from "./comments-event-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports